import React, { useState } from "react";
import { Table } from "antd";

const columns = [
  {
    title: "Invoice ID",
    dataIndex: "invoice_id",
    key: "invoice_id",
  },
  {
    title: "Date",
    dataIndex: "date",
    key: "date",
  },
  {
    title: "Supplier",
    dataIndex: "supplier",
    key: "supplier",
  },
  {
    title: "Invoice No",
    dataIndex: "invoice_no",
    key: "invoice_no",
  },
  {
    title: "Type",
    dataIndex: "type",
    key: "type",
    render: (type) => (
      <span
        className={`rounded-pill px-3 py-2 ${
          type === "RCM" ? "badge-soft-purple" : "badge-soft-primary"
        }`}
        style={{ fontSize: "12px" }}
      >
        {type}
      </span>
    ),
  },
  {
    title: "Amount",
    dataIndex: "amount",
    key: "amount",
  },
  {
    title: "Status",
    dataIndex: "status",
    key: "status",
    render: (status) => {
      const statusClass = {
        Posted: "bg-primary bg-opacity-10 text-primary",
        Draft: "bg-warning bg-opacity-10 text-warning",
        Paid: "bg-success bg-opacity-10 text-success",
      };

      return (
        <span
          className={`badge rounded-pill px-3 py-2 ${statusClass[status]}`}
          style={{ fontSize: "12px" }}
        >
          {status}
        </span>
      );
    },
  },
  {
    title: "GST",
    dataIndex: "gst",
    key: "gst",
    render: () => (
      <span className="rounded-pill px-3 py-2 badge-soft-success">GST</span>
    ),
  },
  {
    title: "Actions",
    key: "actions",
    render: () => (
      <div className="d-flex gap-2">
        <i className="far fa-eye cursor-pointer"></i>
        <i className="far fa-file-pdf cursor-pointer"></i>
        <i className="fas fa-print cursor-pointer"></i>
        <i className="far fa-trash-alt cursor-pointer text-danger"></i>
      </div>
    ),
  },
];

const BankReconciliationStatementImport = () => {
  const [purchaseInvoiceSearch, setPurchaseInvoiceSearch] = useState({
    account: "",
    statement_date: "",
    statement_number: "",
    file_formate: "",
    opening_balance: "",
    closing_balance: "",
    statement_file: "",
  });

  const [dataSourcer, setDataSourcer] = useState([
    {
      key: 1,
      invoice_id: "PI-2025-001",
      date: "2025-01-10",
      supplier: "Air India Cargo",
      invoice_no: "AI-INV-001",
      type: "Regular",
      amount: "₹ 4,50,000",
      status: "Posted",
      gst: "GST",
    },
    {
      key: 2,
      invoice_id: "PI-2025-002",
      date: "2025-01-12",
      supplier: "DHL Express",
      invoice_no: "DHL-2025-345",
      type: "RCM",
      amount: "₹ 2,85,000",
      status: "Posted",
      gst: "GST",
    },
    {
      key: 3,
      invoice_id: "PI-2025-003",
      date: "2025-01-15",
      supplier: "FedEx India",
      invoice_no: "FDX-98765",
      type: "Regular",
      amount: "₹ 1,95,000",
      status: "Draft",
      gst: "GST",
    },
    {
      key: 4,
      invoice_id: "PI-2025-004",
      date: "2025-01-18",
      supplier: "Blue Dart",
      invoice_no: "BD-INV-789",
      type: "Regular",
      amount: "₹ 1,28,000",
      status: "Paid",
      gst: "GST",
    },
  ]);

  const onValueChange = (e) => {
    const { name, type, value, checked } = e.target;

    setPurchaseInvoiceSearch((pre) => ({
      ...pre,
      [name]: type === "checkbox" ? checked : value,
    }));
  };
  return (
    <>
      <style>
        {`
          .padding-pt-9 {
            padding: 10px;
          }
        `}
      </style>

      <div className="card p-4">
        <h5 className="fw-semibold mb-3">Bank Statement Import</h5>
        <div className="row">
          {/* account */}
          <div className="col-12  col-md-6 mb-4">
            <label className="form-label fw-medium">Account </label>
            <input
              type="text"
              name="account"
              className="form-control bg-light"
              value={purchaseInvoiceSearch.account}
              onChange={onValueChange}
              placeholder="Account "
            />
          </div>
          {/* statement_date */}
          <div className="col-12  col-md-6 mb-4">
            <label className="form-label fw-medium">Statement Date</label>
            <input
              type="date"
              name="statement_date"
              className="form-control bg-light"
              placeholder="Enter statement date"
              onChange={onValueChange}
              value={purchaseInvoiceSearch.statement_date}
            />
          </div>

          {/* statement_number */}
          <div className="col-12  col-md-6 mb-4">
            <label className="form-label fw-medium">Statement Number </label>
            <input
              type="text"
              name="statement_number"
              className="form-control bg-light"
              value={purchaseInvoiceSearch.statement_number}
              onChange={onValueChange}
              placeholder="Statement Number "
            />
          </div>

          {/* file_formate */}
          <div className="col-12  col-md-6 mb-4">
            <label className="form-label fw-medium">File Formate</label>
            <select
              name="file_formate"
              className="form-select bg-light padding-pt-9"
              value={purchaseInvoiceSearch.file_formate}
              onChange={onValueChange}
            >
              <option value="">Select File Formate </option>
              <option value="file_formate">File Formate 1</option>
            </select>
          </div>

          {/* opening_balance */}
          <div className="col-12  col-md-6 mb-4">
            <label className="form-label fw-medium">Opening Balance </label>
            <input
              type="text"
              name="opening_balance"
              className="form-control bg-light"
              value={purchaseInvoiceSearch.opening_balance}
              onChange={onValueChange}
              placeholder="Opening Balance "
            />
          </div>

          {/* closing_balance */}
          <div className="col-12  col-md-6 mb-4">
            <label className="form-label fw-medium">Closing Balance </label>
            <input
              type="text"
              name="closing_balance"
              className="form-control bg-light"
              value={purchaseInvoiceSearch.closing_balance}
              onChange={onValueChange}
              placeholder="Closing Balance "
            />
          </div>

          {/* Upload Statement File */}
          <div className="col-12 mb-4">
            <label className="form-label fw-medium">
              Upload Statement File <span className="text-danger">*</span>
            </label>

            <div
              className="border rounded-4 p-5 text-center bg-light"
              style={{
                borderStyle: "dashed",
                borderColor: "#d0d7de",
                cursor: "pointer",
              }}
            >
              {/* Upload Icon */}
              <i
                className="fa fa-upload mb-3"
                style={{ fontSize: "32px", color: "#9aa0a6" }}
              ></i>

              {/* Drop text */}
              <p className="mb-1 fw-semibold text-secondary">
                Drop your bank statement file here or click to browse
              </p>

              {/* Supported formats */}
              <small className="text-muted d-block mb-3">
                Supported formats: CSV, Excel, MT940, PDF
              </small>

              {/* Hidden file input */}
              <input
                type="file"
                id="statementFileInput"
                name="statement_file"
                className="d-none"
                onChange={onValueChange}
              />

              {/* Button */}
              <button
                className="btn btn-light border px-4"
                onClick={() =>
                  document.getElementById("statementFileInput").click()
                }
              >
                Choose File
              </button>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default BankReconciliationStatementImport;
